<template>
  <div class="technical-list-container" :class="{ show: isOpen }">
    <div
      v-for="option in options"
      :key="option.layer"
      v-if="option.visible"
      class="technical-container"
      :class="{ selected: isSelected(option.layer) }"
      @click.stop="$emit('select', option)"
    >
      <component
        :is="isSelected(option.layer) ? option.filledIcon : option.icon"
        class="technical-svg"
      />
      <v-tooltip v-if="option.instructions" top>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" class="technical-text">{{ option.label }}</span>
        </template>
        <span>{{ option.instructions }}</span>
      </v-tooltip>
      <span v-else class="technical-text">{{ option.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreteObjectsToolbarItemOptionsMenu",

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },

    options: {
      type: Array,
      required: true
    },

    currentLayer: {
      type: String,
      required: true
    }
  },

  methods: {
    isSelected(layer) {
      return this.currentLayer === layer;
    }
  }
};
</script>

<style scoped>
.technical-list-container {
  position: absolute;
  bottom: 48px;
  display: none;
  height: fit-content;
  padding-left: 16px;
  width: fit-content;
}

.technical-list-container.show {
  display: block;
  background-color: white;
  border-radius: 3px;
  padding: 4px 14px 0;
  min-width: max-content;
}

.technical-container {
  min-height: 32px;
  display: flex;
  opacity: 1;
}

.technical-container.selected .technical-text {
  background-color: #4fa2b7;
  color: #ffffff;
}

.technical-container.selected .technical-svg > g {
  fill: none;
}

.technical-container:hover .technical-svg {
  width: 28px;
}

.technical-svg {
  width: 24px;
  height: auto;
}

.technical-svg > g {
  fill: white;
}

.technical-text {
  margin: 10px 0;
  line-height: 12px;
  margin-left: 5px;
  padding: 0 5px;
  border-radius: 12px;
  background-color: #ffffff;
  color: #515358;
  font-size: 10px;
  letter-spacing: 0.02px;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Toolbars/CreateObjects/ItemOptionsMenu.vue